import apiClient from "@/axios";

export const getAppHistory = async (historyId) => {
  const response = await apiClient.post("/user/app/history/show", {
    historyId: historyId,
  });
  return response;
};